module.exports = __webpack_public_path__ + "static/media/WilsonArt.37121125.svg";